import { LibraryHelper } from "_helpers/LibraryHelper";
import { PageHelper } from "_helpers/PageHelper";
import MCSConfirmDialog from "components/MCSConfirmDialog";
import MCSGridRevert from "components/MCSGridRevert";
import MCSHeader from "components/MCSHeader";
import MCSOverlayLoading from "components/MCSOverlayLoading";
import { GlobalAlertContext } from "context/GlobalAlertContext";
import React, { useCallback, useEffect, useState } from "react";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { useLocation } from "react-router-dom";
import { SearchApi } from "services/search.service";
import SearchList from "./Components/SearchList";
import SearchNoResult from "./Components/SearchNoResult";
import './SearchPage.css';

const SearchPage = () => {
    const { promiseInProgress } = usePromiseTracker();
    const queryString = require('query-string');
    const location = useLocation();

    const [error, setError] = useState(null);
    const [searchVal, setSearchVal] = useState('');
    const [searchResults, setSearchResults] = useState(null);
    const [totalCount, setTotalCount] = useState(0);
    const [selectedPage, setSelectedPage] = useState(1);
    const PAGE_SIZE = 10;

    const [confirmDialog, setConfirmDialog] = useState(null);

    const fetchDataOnPageChange = (page) => {
        setSelectedPage(page);
        fetchData(page, searchVal);
    };

    const fetchData = async (page, searchVal, alertObj) => {
        let skipCount = PageHelper.GetSkipCount(PAGE_SIZE, page);

        trackPromise(
            SearchApi.searchAll(skipCount, searchVal, PAGE_SIZE)
                .then((result) => {
                    console.log('search result:', result);
                    if (result && result.data) {
                        var response = result.data;
                        setSearchResults(response.items);
                        setTotalCount(response.totalCount);
                    }
                })
                .catch((error) => {
                    if (alertObj)
                        alertObj.setErrorMessage(error.message);
                    else
                        setError(error);
                })
        );
    };

    const handleClickItem = (item, libraryPostType, action) => {
        let data = {
            postId: item.libraryPostId,
            postType: libraryPostType,
            action: action
        };

        if (item.notice != null) {            
            LibraryHelper.openLibraryNoticeDialog(setConfirmDialog, confirmDialog, item.notice, data);            
        } else {
            LibraryHelper.handleLibraryPostOnClick(data);
        }
    }

    const getQuery = useCallback(() => {
        let searchPhrase = queryString.parse(location.search);
        if (!searchPhrase || !searchPhrase.q) {
            return '';
        } else if (!Array.isArray(searchPhrase.q)) {
            return searchPhrase.q;
        } else if (searchPhrase.q.length > 0) {
            return searchPhrase.q[0];
        }
        return '';
    }, [location, queryString]);

    useEffect(() => {
        let query = getQuery();
        setSearchVal(query);
        setSelectedPage(1);
        fetchData(1, query);
    }, [getQuery]);

    if (error) {
        return <div>Error: {error.message}</div>;
    } else {
        return (
            <>
                {promiseInProgress && <MCSOverlayLoading></MCSOverlayLoading>}
                <GlobalAlertContext.Consumer>
                    {(alertObj) => (
                        <>
                            <MCSGridRevert>
                                <MCSHeader header="Search Results" />
                                {searchResults && searchResults.length > 0 &&
                                    <>
                                        <SearchList
                                            promiseInProgress={promiseInProgress}
                                            searchResults={searchResults}
                                            pageSize={PAGE_SIZE}
                                            totalCount={totalCount}
                                            selectedPage={selectedPage}
                                            setSelectedPage={fetchDataOnPageChange}
                                            handleClickItem={handleClickItem}
                                        />
                                        {confirmDialog && (
                                            <MCSConfirmDialog
                                                confirmHandler={LibraryHelper.handleLibraryPostOnClick}
                                                confirmDialog={confirmDialog}
                                                setConfirmDialog={setConfirmDialog}
                                            />
                                        )}
                                    </>
                                }
                                {searchResults && searchResults.length === 0 &&
                                    <SearchNoResult />
                                }
                            </MCSGridRevert>
                        </>
                    )}
                </GlobalAlertContext.Consumer>
            </>
        );
    }
};

export default SearchPage;